module.exports = __webpack_public_path__ + "media/images/ic_support_admin-81a84c3dbc399200c0d1dc00e575dca9.svg";